"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORIGIN_GROUP_WIDGET = exports.ORIGIN_GROUP_OVERVIEW = void 0;
var ORIGIN_GROUP_OVERVIEW = 'JoinViaGroupOverview';
exports.ORIGIN_GROUP_OVERVIEW = ORIGIN_GROUP_OVERVIEW;
var ORIGIN_GROUP_WIDGET = 'JoinViaGroupWidget';
exports.ORIGIN_GROUP_WIDGET = ORIGIN_GROUP_WIDGET;